"use client";
import { useUpdateEffect } from "@ariakit/react-utils";
import * as Core from "@ariakit/components/checkbox/checkbox-store";
import { useStore, useStoreProps } from "@ariakit/react-store";
//#region src/checkbox/checkbox-store.ts
function useCheckboxStoreProps(store, update, props) {
	useUpdateEffect(update, [props.store]);
	useStoreProps(store, props, "value", "setValue");
	return store;
}
function useCheckboxStore(props = {}) {
	const [store, update] = useStore(Core.createCheckboxStore, props);
	return useCheckboxStoreProps(store, update, props);
}
//#endregion
export { useCheckboxStore, useCheckboxStoreProps };

//# sourceMappingURL=checkbox-store.js.map